import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import TableContainer from '@mui/material/TableContainer'
import { alpha, styled } from '@mui/material/styles'

interface StyledTableContainerProps {
  tableHeight: number | string
  tableMinHeight: number
}

export const SubscriptionsPaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  height: '100%',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  backgroundColor: alpha(theme.palette.background.paper, 0.72),
}))

export const SubscriptionsHeaderSection = styled(Box)(({ theme }) => ({
  margin: theme.spacing(1, 1.25, 0),
  padding: theme.spacing(0.85, 1.5),
  borderRadius: theme.spacing(0.75),
  [theme.breakpoints.up('sm')]: {
    margin: theme.spacing(1.15, 1.5, 0),
    padding: theme.spacing(1, 1.5),
  },
  background: `linear-gradient(135deg, ${alpha(theme.palette.info.dark, 0.72)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.6
  )} 100%)`,
  borderBottom: `1px solid ${alpha(theme.palette.common.white, 0.08)}`,
}))

export const SubscriptionsFiltersSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 1.25),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(1.15, 1.5),
  },
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

export const SubscriptionsTableContainer = styled(TableContainer, {
  shouldForwardProp: (prop) =>
    prop !== 'tableHeight' && prop !== 'tableMinHeight',
})<StyledTableContainerProps>(({ tableHeight, tableMinHeight }) => ({
  minHeight: tableMinHeight,
  maxHeight: tableHeight,
  flex: 1,
  overflowX: 'auto',
  overflowY: 'auto',
}))

export const LoadingState = styled(Stack)(() => ({
  minHeight: 260,
}))

export const AlertContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}))

export const ExpandedContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
}))

export const EmptyTransactionsAlert = styled(Alert)(() => ({
  width: '100%',
}))
